import { createSlice, type PayloadAction, createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../configuration/setup/store';
import { Mission, MissionSocket } from './missions.types';
import { MISSION_STATUS_ORDER } from '../../constants';

interface MissionsState {
    missions: Mission[];
}

export const initialState: MissionsState = {
    missions: [],
};

const missionsSlice = createSlice({
    name: 'missionsStore',
    initialState,
    reducers: {
        storeMissions: (state, action: PayloadAction<Mission[]>) => {
            state.missions = action.payload;
        },
        deleteMission: (state, action: PayloadAction<Mission['missionId']>) => {
            const allMission = state.missions.filter((mission) => mission.missionId !== action.payload);
            state.missions = allMission;
        },
        addMission: (state, action: PayloadAction<Mission>) => {
            state.missions.push(action.payload);
        },
        storeMission: (state, action: PayloadAction<MissionSocket>) => {
            const missionIndex = state.missions.findIndex((mission) => mission.missionId === action.payload.missionId);

            if (missionIndex !== -1) {
                state.missions[missionIndex] = { ...state.missions[missionIndex], ...action.payload };
            }
        },
    },
});

export const { storeMissions, storeMission, deleteMission, addMission } = missionsSlice.actions;

export const getMissions = createSelector(
    (state: RootState) => state.missionsStore.missions,
    (missions) => {
        if (!missions) {
            return [];
        }

        return missions.map((mission) => ({
            ...mission,
            statusPriority: MISSION_STATUS_ORDER[mission.missionStatus] ?? undefined,
        }));
    }
);
export const findMission = (state: RootState, missionId: Mission['missionId']) => {
    return state.missionsStore.missions.find((mission) => mission.missionId === missionId);
};

export default missionsSlice.reducer;
